import { styled } from "@mui/material";
import { COLORS } from "./Theme";

export const ListBox = styled("div")({
  boxShadow: "0 16px 32px -4px #0C0C0D1A",
  zIndex: 2,
  minWidth: "187px",
  display: "flex",
  opacity: 1,
  flexDirection: "column",
  gap: "8px",
  transition: "opacity 0.3s ease",
  borderRadius: "10px",
  backgroundColor: "#FFFFFF",
  padding: "10px 12px",
});

export const ListTitle = styled("p")({
  px: "6px",
  fontWeight: 900,
  fontSize: "14px",
  textAlign: "left",
});

export const ListDivider = styled("hr")({
  opacity: 0.1,
});

export const ListItem = styled("p")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "6px",
  borderRadius: "7px",
  fontSize: "12px",
  background: COLORS.SOFTGRAY,
  cursor: "pointer",
  ":hover": {
    background: COLORS.SOFTBLUE,
    color: COLORS.BLUE,
  },
});

export const ListItemLabel = styled("span")({
  fontSize: "12px",
});
